import { Injectable } from '@angular/core';
import { CarQuoteLiteRiskInfo } from '../../shared/models/car-quote-lite-risk-info.model';
import { CarQuoteLitePolicyInfo } from '../../shared/models/car-quote-lite-policy-info.model';
import { StringExtensions } from 'app/modules/ca7-claim/helpers/string-extensions';
import { CarQuoteLitePostalCode } from 'app/modules/car-quote-lite/models/car-quote-lite-request.model';
import { PaymentType } from '@sc/leads-admin/models';
@Injectable({
  providedIn: 'root'
})
export class CarQuoteLiteStorageService {
  public draftId: number;
  public risk: CarQuoteLiteRiskInfo;
  public policy: CarQuoteLitePolicyInfo;
  public taxes: any;
  public isCarQuoteLiteDataSet = false;
  public paymentMethods: Array<any>;
  public affinityGroupId: string;
  public affinityGroupDiscount: number;
  public postalCode: CarQuoteLitePostalCode;
  public opportunityId: number;

  constructor() {
    this.clear();
  }

  setRisk(risk: CarQuoteLiteRiskInfo) {
    this.risk = risk;
  }

  setPolicy(policy: CarQuoteLitePolicyInfo) {
    const newPolicy = { ...this.policy, ...policy };
    this.policy = newPolicy;
  }

  setTaxes(taxes: any) {
    this.taxes = taxes;
  }

  setAffinityGroup(id: string, discount: number) {
    this.affinityGroupId = id;
    this.affinityGroupDiscount = discount;
  }

  clear() {
    this.draftId = null;
    this.risk = null;
    this.isCarQuoteLiteDataSet = false;
    this.paymentMethods = this.calculatePaymentMethods();
    const policy = new CarQuoteLitePolicyInfo();
    policy.paymentMethod = this.paymentMethods[0];
    policy.commercialAlternative = 0;
    policy.fee = { key: 6, value: '6', name: '6' };
    this.setPolicy(policy);
    this.taxes = null;
    this.affinityGroupDiscount = null;
    this.affinityGroupId = '';
    this.postalCode = null;
  }

  private calculatePaymentMethods() {
    return [
      'Efectivo / Cheque',
      'Débito en tarjeta',
      'Débito en cuenta'
    ].map((each, index) => ({
      paymentType: each,
      title: each,
      paymentTypeId: (index + 1).toString(),
      hideAmount: true
    }));
  }

  setCarQuoteLiteData(data) {
    this.clear();
    if (data.riskData) {
      delete data.riskData.statedAmount;
      this.setVehicle(data);
      this.setRisk(data.riskData);
    }
    const policy = {
      commercialAlternative: data.commercialAlternative,
      automaticAdjustment: data.automaticAdjustment
    }
    this.setPolicy(policy);
    this.opportunityId = data.opportunitiesId;
    this.isCarQuoteLiteDataSet = true;
    data.postalCode && this.setPostalCode(data);
    data.quotes && data.quotes.length && this.setPaymentMethod(data.quotes[0]);
  }

  setPaymentMethod(data) {
    let paymentMethodId = 0;
    switch (data.paymentMethod) {
      case 'EFECTIVO': paymentMethodId = PaymentType.Efectivo;
        break;
      case 'CREDITO': paymentMethodId = PaymentType.Credito;
        break;
      case 'DEBITO': paymentMethodId = PaymentType.Debito;
        break;
    }
    this.policy.paymentMethod = this.paymentMethods[paymentMethodId];
    this.policy.fee = { key: data.paymentFee, value: data.paymentFee.toString(), name: data.paymentFee.toString() };
  }

  setVehicle(data) {
    data.riskData.year = (data.riskData.year) ? this.modelMapper((data.riskData.year).toString()) : null;
    data.riskData.make = this.modelMapper((data.riskData.makeKey));
    data.riskData.model = this.modelMapper((data.riskData.modelKey));
  }

  setPostalCode(location) {
    this.postalCode = {
      postalCode: location.postalCode.toString(),
      postalSynonym: location.cityKey,
      state: {
        key: location.stateKey,
        name: StringExtensions.toTitleCase(location.cityName)
      },
      key: `${location.postalCode}-${location.cityKey}`,
      name: StringExtensions.toTitleCase(location.cityName)
    };
  }

  getCommercialAlternativeByAffinity() {
    const commercialLabel = `${Math.abs(this.affinityGroupDiscount)}% de ${(Math.sign(this.affinityGroupDiscount) === -1) ? 'descuento' : 'recargo'} en la prima`;

    return {
      key: this.affinityGroupDiscount,
      value: commercialLabel,
      name: commercialLabel
    };
  }

  modelMapper(param: string) {
    return { key: param, name: param };
  }
}
